import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function InformationAndVideo() {
  return <section data-section-id="88704" id="empresa" className="bg-background text-foreground py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          
          {}
          <div className="flex flex-col justify-center">
            <h2 className="font-default text-3xl md:text-5xl font-bold text-primary mb-8 tracking-tighter">
              Excelência em Engenharia e Soluções Globais
            </h2>
            <div className="space-y-6 text-foreground font-sans text-lg leading-relaxed">
              <p>
                A Doctorice consolidou-se como referência global no setor de engenharia, entregando soluções de alta performance que transformam desafios complexos em resultados mensuráveis. Nossa trajetória é pautada pelo rigor técnico e pelo compromisso inabalável com a excelência operacional em cada projeto de infraestrutura.
              </p>
              <p>
                Com 15 anos de experiência e atuação em mais de 20 países, nossa equipe multidisciplinar desenvolve tecnologias proprietárias que otimizam processos industriais em escala mundial. Assista ao vídeo institucional para conhecer nossa infraestrutura de ponta e os valores que impulsionam nossa engenharia de precisão.
              </p>
            </div>
          </div>

          {}
          <div className="w-full">
            <AspectRatio ratio={16 / 9} className="border border-border bg-muted shadow-2xs">
              <iframe className="w-full h-full border-0" src="https://www.youtube-nocookie.com/embed/ScMzIvxBSi4?si=placeholder" title="Vídeo Institucional Doctorice" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </AspectRatio>
          </div>

        </div>
      </div>
    </section>;
}